<script setup>

import Shared from '@/common/shared'
import {Regions} from '@/common/api.service'
import {toRefs, defineProps, ref, onMounted} from 'vue'
import ValidateInput from '@/components/validate/input.vue'
import {useToast} from 'vue-toastification'

const toast = useToast()
const props = defineProps({
  contact: {},
  item: {}
})
const {contact, item} = toRefs(props)
const itemFields = ref([])
const setRef = (el) => {
  itemFields.value.push(el)
}

async function save() {
  let isValid = true
  itemFields.value.forEach((f) => {
    f.validate()
    if (f.validationFailed) {
      isValid = false
    }
  })

  if (isValid) {
    if (!contact.value.id) {
      await postNew()
    } else {
      await post()
    }
    await close()
  } else {
    toast.error('Контакт не сохранен, проверьте обязательные поля', {
      timeout: 5000
    })
  }
}

async function close() {
  Shared.closeModal('#contact-form')
  Shared.closeModal('#del-contact-form')
  Shared.closeModal('#deleted-contact')
  contact.value.npaModal = false
}

async function postNew() {
  await Regions.createContact(item.value.region.id, contact.value).then((data) => {
    contact.value.id = data.data
    item.value.npaContacts.push(contact.value)
  })
}

async function post() {
  await Regions.updateContact(item.value.region.id, contact.value.id, {
    'fullName': contact.value.fullName,
    'occupation': contact.value.occupation,
    'phone': contact.value.phone,
    'email': contact.value.email,
    'comment': contact.value.comment,
    'contactType': contact.value.contactType,
  })

}

async function remove() {
  await Regions.removeContact(item.value.region.id, contact.value.id)
  item.value.npaContacts.forEach(function (f, k) {
    if (f.id === contact.value.id) {
      item.value.npaContacts.splice(k, 1)
    }
  })
  Shared.showModal('#del-contact-form')
  Shared.showModal('#deleted-contact')
}

async function showRemove() {
  Shared.closeModal('#contact-form')
  Shared.showModal('#del-contact-form')
}

onMounted(() => {
  if (!contact.value.phone) {
    contact.value.phone = '+7'
  }
  Shared.showModal('#contact-form')
})

</script>

<template>
  <div class="modal-overlay" id="contact-form">
    <div class="popup popup-oy-auto">
      <div class="modal-title title-h2" v-if="!contact.id">Добавление контактного лица СПИК</div>
      <div class="modal-title title-h2" v-else>Редактирование контактного лица СПИК</div>
      <div class="modal-body">
        <ValidateInput
            :name="'ФИО'"
            placeholder="Введите ФИО"
            :ref="setRef"
            required
            maxlength="500"
            v-model="contact.fullName">
        </ValidateInput>
        <ValidateInput
            :name="'Должность'"
            placeholder="Введите должность"
            :ref="setRef"
            required
            maxlength="250"
            v-model="contact.occupation">
        </ValidateInput>
        <ValidateInput
            :name="'Номер телефона'"
            placeholder="Введите номер телефона"
            :ref="setRef"
            required
            maxlength="255"
            v-model="contact.phone">
        </ValidateInput>
        <ValidateInput
            :name="'E-mail'"
            placeholder="Введите адрес электронной почты"
            :ref="setRef"
            email
            required
            maxlength="255"
            v-model="contact.email">
        </ValidateInput>
        <ValidateInput
            :name="'Комментарий'"
            textarea
            placeholder="Введите комментарий"
            :ref="setRef"
            maxlength="1024"
            v-model="contact.comment">
        </ValidateInput>
      </div>
      <div class="modal-bottom">
        <div class="buttons-block">
          <button type="submit" class="button button--delete" v-if="contact.id" @click="showRemove">
            Удалить
          </button>
          <button type="button" class="button button--clear" @click="close">закрыть
          </button>
          <button type="submit" class="button" @click="save">СОХРАНИТЬ</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-overlay" id="del-contact-form">
    <div class="popup">
      <div class="modal-title">Удаление контакта</div>
      <div class="modal-body">Вы действительно хотите удалить контакт?</div>
      <div class="modal-bottom button-dialog-center">
        <div class="buttons-block">
          <button type="button" class="button button--clear" @click="close">Закрыть
          </button>
          <button type="submit" class="button button--delete" @click="remove">Удалить</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-overlay" id="deleted-contact">
    <div class="popup">
      <div class="modal-title">Контакт удален</div>
      <div class="modal-body"></div>
      <div class="modal-bottom">
        <div class="buttons-block">
          <button type="button" class="button" @click="close">Закрыть</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>